export const UserWithdrawalStatus = {
    APPROVE_BY_ADMIN: 13,
    REFERRAL_AUTO_APPROVED: 15,
};
